var IntlInitializer = function (visibleInput, hiddenInput, options) {
    this.init(visibleInput, hiddenInput, options);
};


jQuery.extend(IntlInitializer.prototype, {

    iti : null,
    errorMap : {
        0: "Invalid number",
        1: "Invalid country code",
        2: "Too short",
        3: "Too long",
        4: "Invalid number",
        '-99' : "error_value_is_empty"
    },
    $input : null,
    $hiddenInput : null,
    options : {
        showError : true, //show error
        showErrorBorder : true, // show red border on error
        required : true,  // is field required
        initialCountry: null, //preselect country on init
        nationalMode: false,
        startCheck: true,  //show error on init
        allowedPrefix: false,  //filter country list by prefix
        countryPrefix: null,
        countryPrefixId: null,
        triggerChangeHidden : false, //add keyup event as change to hidden input, works only with hiddenInput value
        loadUtilsOnInit: "/v2/lib/intl-tel-input/js/utils.js",
        errorTemplate: "<p class=\"input-error\">{{error}}</p>",
        onValid : null,
        onNotValid : null,
        validationNumberType: null,//"FIXED_LINE_OR_MOBILE",
    },

    _validHandlers : [],
    _notValidHandlers : [],

    init: function (visibleInput, hiddenInput, options) {
        var _this = this;
        if(options){
            this.options = jQuery.extend(this.options, options);
        }
        if(this.options.errors){
            this.setErrorsText(this.options.errors);
        }
        this.$input = jQuery(visibleInput, this.container);

        if(hiddenInput) {
            this.$hiddenInput = jQuery(hiddenInput, this.container);

            this.options.hiddenInput = null;/*function(telInputName) {
                return {
                    phone: _this.$hiddenInput.data('id'),
                    //country: "country_code"
                };
            };*/
        }

        if(this.options.onValid){
            this.onValid(this.options.onValid);
        }
        if(this.options.onNotValid){
            this.onNotValid(this.options.onNotValid);
        }

        this.initPhoneInput();

        if(window.intlTelInput && window.intlTelInput.utils) {
            window.intlTelInputUtils = window.intlTelInput.utils;
        }

        jQuery(document).on( 'focusin', '.iti__search-input', function(e){
            e.preventDefault();
            return false;
        });
    },

    _getInitialCountyByPrefix : function(prefix){
        var initialCountry = null;
        if(prefix && window.intlTelInput){
            var countryData = window.intlTelInput.getCountryData();
            prefix = String(prefix).replace( /^\D+/g, '');

            for (var i = 0; i < countryData.length; i++) {
                var ccountry = countryData[i];

                if(ccountry && ccountry.dialCode === prefix){
                    initialCountry = ccountry.iso2;
                }
            }
        }
        return this._rewriteCountryPrefix(initialCountry);
    },

    _getAllowedCountriesByPrefix : function(prefix){
        var countries = [];
        if(prefix && window.intlTelInput){
            var countryData = window.intlTelInput.getCountryData();
            prefix = String(prefix).replace( /^\D+/g, '');

            for (var i = 0; i < countryData.length; i++) {
                var ccountry = countryData[i];

                if(ccountry && ccountry.dialCode === prefix){
                    countries.push(ccountry.iso2);
                }
            }
        }

        if(!countries.length && prefix){
            prefix = prefix.substring(0, prefix.length - 1);
            countries = this._getAllowedCountriesByPrefix(prefix);
        }

        return countries;
    },

    initPhoneInput : function(){
        var _this = this;

        var _onScriptReady = function () {
           // window.intlTelInputGlobals.windowLoaded = true;

            var opts = jQuery.extend({}, _this.options);
            var initialCountry = null;

            if(opts.countryPrefixId) {
                opts.countryPrefixId = _this._rewriteCountryPrefix(opts.countryPrefixId);
            }

            if(opts.countryPrefixId){
                opts.initialCountry = String(opts.countryPrefixId).toLowerCase();
            }else  if(opts.countryPrefix) {
                initialCountry = _this._getInitialCountyByPrefix(opts.countryPrefix);
                if(initialCountry) {
                    opts.initialCountry = initialCountry;
                }
            }

            if(opts.allowedPrefix){
                opts.onlyCountries = _this._getAllowedCountriesByPrefix(opts.countryPrefix);

                if(opts.countryPrefixId){
                    opts.onlyCountries = [String(opts.countryPrefixId).toLowerCase()];
                }
            }

            if(!opts.initialCountry){
                initialCountry = null;
                var companyConfig = _this.getParam('company_info', {});
                var initialCCountry = _this.getParam('country_phone_initial',null);
                var country = _this.getParam('country', null);

                if(initialCCountry){
                    initialCountry = String(initialCCountry).toLowerCase();
                } else {
                    if (country) {
                        initialCountry = String(country).toLowerCase();
                    }

                    if (companyConfig && companyConfig.country_id) {
                        initialCountry = String(companyConfig.country_id).toLowerCase();
                    }
                }

                opts.initialCountry = initialCountry;
            }

            if(opts.onlyCountries && opts.initialCountry){
                if(opts.onlyCountries.indexOf(opts.initialCountry) === -1){
                    opts.initialCountry = opts.onlyCountries[0];
                }
            }

            if(opts.initialCountry){
                opts.initialCountry = _this._rewriteCountryPrefix(opts.initialCountry);
            }
            console.log(opts);

            _this.iti = window.intlTelInput(_this.$input.get(0), opts);

            if(window.intlTelInput && window.intlTelInput.utils) {
                window.intlTelInputUtils = window.intlTelInput.utils;
            }

            if(_this.iti && _this.iti.promise){
                _this.iti.promise.then(function() {
                    _this.$input.trigger('iti-ready');
                    if(_this.getParam('startCheck', true)) {
                        _this._onPhoneInputChange();
                    }
                });
            }

            var inputEvents = 'change countrychange';
            if(_this.getParam('triggerChangeHidden')) {
                inputEvents += ' keyup';
            }
            _this.$input.on('change countrychange keyup', function () {
                _this._onPhoneInputChangeAlways();
            });

            _this.$input.on(inputEvents, function () {
                _this._onPhoneInputChange();
            });
        };

        if(!window.intlTelInput) {
            _this.getScript("/v2/lib/intl-tel-input/js/intlTelInput.js", function () {
                _onScriptReady();
            });
        } else {
            _onScriptReady();
        }
    },

     getScript: function(url, callback) {
         var script = document.createElement('script');
         script.src = url;
         script.type = 'text/javascript';

         script.onload = function() {
             if (typeof callback === 'function') {
                 callback();
             }
         };

         script.onerror = function() {
             console.error('Error loading script: ' + url);
         };

         document.head.appendChild(script);
     },

    _onPhoneInputChangeAlways : function(){
        var _this = this;
        if(!this.iti){
            console.warn('input not initialized');
            return;
        }
        var callNext = true;
        jQuery.each((this.isPhoneValid()?this._validHandlers:this._notValidHandlers), function (n, handler) {
            if(typeof handler == 'function' && callNext){
                var r = handler(_this.getError());
                if(r === false){
                    callNext = false;
                }
            }
        });
    },

    _onPhoneInputChange : function(){
        if(!this.iti){
            console.warn('input not initialized');
            return;
        }
        var showError = this.getParam('showError', true);
        var showErrorBorder = this.getParam('showErrorBorder', true);

        var $formGroup = this.$input.closest('.form-group');
        if(showErrorBorder) {
            $formGroup.removeClass('has-error');
        }
        if(showError) {
            $formGroup.find('.invalid-feedback, .input-error').remove();
        }
        var number = this.iti.getNumber();

        if(this.$hiddenInput) {
            this.$hiddenInput.val(number).trigger('change');
        }

        if(!this.isPhoneValid()){
            if(showError) {
                var errorMsg = this.getError();
                var output = jQuery('<p class="input-error">' + Locale.get(errorMsg) + '</p>');

                if(this.getParam('errorTemplate')){
                    output = jQuery(String(this.getParam('errorTemplate')).replace('{{error}}', Locale.get(errorMsg)));
                }
                output.addClass('invalid-feedback');
                output.insertAfter($formGroup.find('.iti'));
            }
            if(showErrorBorder) {
                $formGroup.addClass('has-error');
            }
        }
    },

    getInstance : function () {
        return this.iti;
    },

    isPhoneValid : function(){
        if(this.iti){
            var required = this.getParam('required', true);
            var number = this.iti.getNumber();
            var isNotValid = !this.iti.isValidNumber() && (required || (!required && number));
            return !isNotValid;
        }
        return false;
    },

    getError : function(){

        console.log(this.isPhoneValid());

        if(!this.isPhoneValid() && this.iti){
            var errorCode = this.iti.getValidationError();

            var errorMsg = this.errorMap[errorCode];
            if(!errorMsg){
                errorMsg = this.errorMap[0];
            }
            return errorMsg;
        }
        return '';
    },

    getParam: function (paramKey, defaultValue) {
        if (jQuery.type(this.options[paramKey]) === 'undefined') {
            return defaultValue;
        }
        return this.options[paramKey];
    },

    setErrorsText : function(errors){
        var _this = this;
        var i = 0;

        console.trace(errors);

        this.errorMap = jQuery.extend(this.errorMap, errors);
    },

    setErrorText : function(n, error){
        if(error){
            this.errorMap[n] = error;
        }
    },

    setCountry : function (id) {
        if(this.iti) {
            this.iti.setCountry(id);
        }
    },

    onValid : function (handler) {
        this._validHandlers.push(handler);
    },

    onNotValid : function (handler) {
        this._notValidHandlers.push(handler);
    },

    _rewriteCountryPrefix : function(prefix){
        if(String(prefix).toUpperCase() === 'AN'){ // Netherlands Antilles not exist in Intl lib, must be Curaçao
            return 'CW';
        }
        return prefix;
    },
});


define("google.intl.phone.init", ["jquery"], function(){});

